import { Heading, Text } from '../../styledComponents';
import styles from './BrandDescription.module.css';

type BrandDescriptionProps = {
  title: string;
  description: string | string[];
  colors:
    | {
        headline: string;
        subText: string;
      }
    | undefined;
  ctaColor: string;
  fontStyle:string;
};

export default function BrandDescription({ title, description, colors, ctaColor, fontStyle }: BrandDescriptionProps) {
  return (
    <div className={styles.brandDescription}>
      <Heading
        as="h2"
        color={colors?.headline}
        fontSize="16px"
        fontWeight="500"
        lineHeight="20px"
        textTransform="uppercase"
        fontFamily={fontStyle}
      >
        {title}
      </Heading>
      {typeof description === 'string' ? (
        <Text
          as="pre"
          ctaColor={ctaColor}
          fontFamily={fontStyle}
          color={colors?.subText}
          dangerouslySetInnerHTML={{ __html: description.replace(/- /g, '• ') }}
        />
      ) : (
        <ul>
          {description?.map((item) => (
            <li style={{ color: colors?.subText }} key={item}>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
